import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

let slider = new Swiper(".appraisal-slider", {
    slidesPerView: 1,
    spaceBetween: 100,
    loop: false,
    autoHeight: true,
    navigation: {
        nextEl: ".new-about-independent-appraisal__slider-mobile > .new-about-independent-appraisal__list-next",
        prevEl: ".new-about-independent-appraisal__slider-mobile > .new-about-independent-appraisal__list-prev",
    },
    pagination: {
        el: ".new-about-independent-appraisal__slider-mobile > .new-about-independent-appraisal__slider-pagination",
        clickable: true,
    },
    breakpoints: {
        1141: {
            pagination: {
                el: ".new-about-independent-appraisal__list > .new-about-independent-appraisal__slider-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".new-about-independent-appraisal__list > .new-about-independent-appraisal__list-next",
                prevEl: ".new-about-independent-appraisal__list > .new-about-independent-appraisal__list-prev",
            },
            autoHeight: false,
        },
    },

});
